<template>
    <div class="open-positions__bottom bottom" id="bottom">
        <div class="uk-section uk-padding-xlarge-top uk-padding-2xlarge-bottom dr-divider-gray-1 dr-divider-flip-horizontal">
            <div class="uk-container">
                
                <div class="uk-flex uk-flex-between" :class="{mobile: isMobile}">
                    <div class="open-positions__sidebar sidebar filter-wrap uk-visible@m">
                        <div class="open-positions__filter-by uk-h5 uk-margin-small-bottom">
                            <span>{{ $t("message.filter_by") }}</span>
                        </div>
                        <checkbox-filter
                            :title="$t('message.departments')"
                            :items="$root.source.job_data.departments"
                            :active-items="activeFilters.department"
                            filter-key="departments"
                            :is-department="true"
                            @filter-updated="$parent.setFilterDept"
                            v-if="!isMobile"
                        ></checkbox-filter>

                        <checkbox-filter
                            class="uk-margin-large-top"
                            :title="$tc('message.location', 2)"
                            :items="availableLocations"
                            :active-items="activeFilters.locations"
                            filter-key="locations"
                            :scrollable="true"
                            @filter-updated="$parent.setFilterLocations"
                            v-if="!isMobile"
                        ></checkbox-filter>
                    </div>

                    <div class="open-positions__content content">
                        <!-- Mobile filters -->
                        <div class="uk-hidden@m uk-margin-bottom">
                             <div class="open-positions__filter-by uk-h5 uk-margin-small-bottom">
                                <span>{{ $t("message.filter_by") }}</span>
                            </div>
                            <div class="uk-margin-small-bottom">
                                 <dropdown-filter
                                    filter-key="departments"
                                    :active-items="activeFilters.department"
                                    :close-on-select="true">
                                    <checkbox-filter
                                        :title="$t('message.departments')"
                                        :items="$root.source.job_data.departments"
                                        :active-items="activeFilters.department"
                                        filter-key="departments"
                                        :is-department="true"
                                        @filter-updated="$parent.setFilterDept"
                                    ></checkbox-filter>
                                </dropdown-filter>
                            </div>
                            <div>
                                <dropdown-filter
                                    filter-key="locations"
                                    :active-items="activeFilters.locations">
                                    <checkbox-filter
                                        :title="$tc('message.location', 2)"
                                        :items="availableLocations"
                                        :active-items="activeFilters.locations"
                                        filter-key="locations"
                                        @filter-updated="$parent.setFilterLocations"
                                    ></checkbox-filter>
                                </dropdown-filter>
                            </div>
                        </div>

                        <div class="open-positions__status status uk-h4 uk-margin-small-bottom" v-html="list_status_message"></div>

                        <div v-if="activeDept" class="uk-padding uk-border-rounded uk-background-muted uk-margin-large-bottom uk-animation-fade">
                            <div class="uk-h4">{{ activeDept.post_title }}</div>
                            <div>{{ activeDept.post_content }}</div>
                        </div>

                        <div class="open-positions__search search uk-margin-bottom uk-flex uk-flex-middle uk-visible@m">
                            <label for="item-search" class="uk-search uk-search-navbar uk-width-1-1">
                                <input v-model.trim="search" type="text" name="item-search" id="item-search" class="uk-input" :placeholder='$t("message.find_role")'>
                                <span v-if="!search.length" class="uk-icon uk-search-icon uk-search-icon-flip" uk-icon="search-navbar"></span>
                                <a v-else class="uk-icon uk-form-icon uk-form-icon-flip" uk-icon="close" @click="search = ''" role='button'></a>
                            </label>
                        </div>

                        <active-filters v-show="filterArgs.length" :items="filterArgs" @filter-arg-removed="$parent.deleteFilterArg" @cleared-filters="$parent.clearFilters(); clearSearch()"></active-filters>

                        <jobs-skeleton v-if="$root.isLoading"></jobs-skeleton>
                        <div v-else class="job-list" :class="{table: !isMobile}">
                            <div class="uk-grid uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@l" uk-grid>
                                <div v-for="item in paginatedJobs" :key="item.id">
                                    <job-item :job="item" :dept-name="getDeptName(item.departments[0])"></job-item>
                                </div>
                            </div>
                        </div>
                        
                        <div class="uk-text-center uk-margin-xlarge-top" v-if="totalPages > 1 && !$root.isLoading">
                            <div class="uk-display-inline-block">
                                <paginate
                                    v-model="currentPage"
                                    :page-count="totalPages"
                                    :click-handler="handlePageChange"
                                    container-class="uk-pagination"
                                    :firstLastButton="false"
                                    :hidePrevNext="true"
                                    next-class="uk-prev"
                                    prev-class="uk-next"
                                    active-class="uk-active"
                                    page-class="dr-pagination-item"
                                    disabled-class="uk-disabled">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-section uk-section-default uk-padding-3xlarge-top" v-if="benefits">
            <div class="uk-container">
                <div class="uk-h2 uk-text-center uk-margin-xlarge-bottom">{{ benefits.title }}</div>
                <div class="uk-grid uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-large" uk-grid>
                    <div v-for="item in benefits.items">
                        <div>
                            <div class="uk-h5">{{ item.title }}</div>
                            <div class="uk-text-caption">{{ item.description }}</div>
                        </div>
                    </div>
                </div>
                <div class="uk-margin-2xlarge-top">
                    <a :href="url_base + 'about-us'" class="uk-button uk-button-primary uk-margin-auto">
                        <span>{{ $t("message.learn_about_dr") }}</span>
                        <span class="uk-icon" uk-icon="chevron-right"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import bus from '../event-bus';
  import ActiveFilters from './ActiveFilters.vue';
  import CheckboxFilter from './CheckboxFilter.vue';
  import DropdownFilter from './DropdownFilter.vue';
  import JobItem from './JobItem.vue';
  import JobsSkeleton from './JobsSkeleton.vue';
  import Paginate from 'vuejs-paginate';
  import vClickOutside from "v-click-outside";

  export default {
    name: 'IndexBottom',
    components: {
      'job-item': JobItem,
      'active-filters': ActiveFilters,
      'checkbox-filter': CheckboxFilter,
      'dropdown-filter': DropdownFilter,
      'jobs-skeleton': JobsSkeleton,
      'paginate': Paginate,
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    props: ['activeFilters'],
    data() {
      return {
        search: '',
        postsPerPage: 9,
        currentPage: 1,
        currentFilterAccordion: '',
        windowWidth: window.innerWidth,
      }
    },
    computed: {
      filterArgs: function(){
        // Formatted filter parameters used to build a list of active filters below search field
        let args = [];
        if (this.activeFilters.department && this.activeFilters.department.length) {
          for (let el of this.activeFilters.department){
            args.push({
              type: 'department',
              value: el,
              displayName: this.getDeptName(el),
            });
          }
        }
        if (this.activeFilters.locations && this.activeFilters.locations.length) {
          for (let el of this.activeFilters.locations){
            args.push({
              type: 'locations',
              value: el,
              displayName: this.getLocationName(el),
            });
          }
        }
        return args;
      },
      activeDept: function(){
        if (this.activeFilters.department.length) {
          return this.getDept(this.activeFilters.department[0])
        } else {
          return ''
        }
      },
      activeDeptName: function(){
        if (this.activeFilters.department.length) {
          return this.getDeptName(this.activeFilters.department[0])
        } else {
          return ''
        }
      },
      activeLocationsName: function(){
        switch (this.activeFilters.locations.length) {
          case 0:
            return this.$t("message.all_locations");
          case 1:
            return this.getLocationName(this.activeFilters.locations[0]);
          default:
            return this.activeFilters.locations.length + ' ' + this.$tc('message.location', 1);
        }
      },
      filteredByDept: function(){
        if (this.activeFilters.department.length) {
          return this.$root.source.job_data.jobs.filter(item => {
            return item.departments[0] === this.activeFilters.department[0]
          });
        }

        return this.$root.source.job_data.jobs;
      },
      filteredByLocation: function(){
        if (this.activeFilters.locations.length) {
          return this.filteredByDept.filter(item => {
			  let decider = false;
			  for (let key in item.Locations){
				  if (this.activeFilters.locations.indexOf(item.Locations[key].id) > -1){
					  decider = true;
				  }
			  }
			  return decider;
          });
        }

        return this.filteredByDept;
      },
      filteredJobs: function(){
        let filteredJobs = this.$root.source.job_data.jobs;

        if (this.filteredByDept){
          filteredJobs = this.filteredByDept;
        }

        if (this.filteredByLocation){
          filteredJobs = this.filteredByLocation;
        }

        if (this.search.length){
          filteredJobs = filteredJobs.filter(item => {
            return item.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
                   item.JobDescription.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          });
        }

        //return this.$root.source.job_data.jobs // -- show all posts

        return filteredJobs;
      },
      totalPages() {
        return Math.ceil(this.filteredJobs.length / this.postsPerPage);
      },
      paginatedJobs() {
        const start = (this.currentPage - 1) * this.postsPerPage;
        const end = start + this.postsPerPage;
        return this.filteredJobs.slice(start, end);
      },
      availableLocations: function(){
        let locations = [];
        for (let job of this.filteredByDept){
			for ( let location in job.Locations){
                locations.push(job.Locations[location]);
			}
        }

        // Remove duplicate locations
        locations = locations.filter((item,index) => {
            return index === locations.findIndex(obj => {
                return JSON.stringify(obj) === JSON.stringify(item);
            });
        });

        // Sort locations alphabetically
        locations.sort(function (a,b) {
            if (a.name < b.name)
              return -1;
            if (a.name > b.name)
              return 1;
            return 0;
        })

        return locations;
      },
      currentJobCount: function(){
        return this.filteredJobs.length
      },
      url_base: function(){
        return this.$root.source.page.lang === 'ja' ? '/jp/' : '/'
      },
      list_status_message: function(){
        if (this.currentJobCount > 0) {
            if (this.activeFilters.department.length) {
                return this.$tc('message.view_dept_pos', this.currentJobCount, { number: `<b>${this.currentJobCount}</b>`, department: this.activeDeptName, location: this.activeLocationsName });
            } else {
                return this.$tc('message.view_open_pos', this.currentJobCount, { number: `<b>${this.currentJobCount}</b>`, location: this.activeLocationsName });
            }
        } else {
          if (this.search.length) {
            return this.$t('message.no_items');
          } else {
              return this.$t('message.no_open_dept', { department: this.activeDeptName, location: this.activeLocationsName });
          }
        }
      },
      isMobile: function(){
        return this.windowWidth <= 960
      },
      benefits: function(){
        return this.$root.source.page ? this.$root.source.page.benefits : '';
      },
    },
    watch: {
      filteredJobs() {
        this.currentPage = 1;
      },
    },
    methods: {
      getDeptName(id) {
        if (!id) return;

        for (let item of this.$root.source.job_data.departments){
          if (item.id === id){
            return item.name;
          }
        }
      },
      getDept(id){
          return this.$root.source.departments.find(obj => {
              return obj.dept_id === id
          })
      },
      getLocationName(id){
          if (id === 'multiple'){
              return this.$t('message.multiple_locations')
          }
          if (id && id.length) {
              if (this.$root.source.job_data.locations && typeof this.$root.source.job_data.locations === 'object') {
                  for (let item of Object.values(this.$root.source.job_data.locations)){
                      if (item.id === id){
                          return item.name;
                      }
                  }
              }
          }
      },
      handleResize: function(event){
        this.windowWidth = event.currentTarget.innerWidth;
      },
      clearSearch: function(){
        this.search = '';
      },
      handlePageChange(pageNum) {
        this.currentPage = pageNum;
        const bottomEl = document.getElementById('bottom');
        if (bottomEl) {
            bottomEl.scrollIntoView({ behavior: 'smooth' });
        }
      },
    },
    mounted: function(){
      bus.$on('clear-search', this.clearSearch);
      window.addEventListener('resize', this.handleResize);
    //   window.addEventListener('click', this.handleClick);
    },
    beforeDestroy: function () {
      bus.$off('clear-search', this.clearSearch);
      window.removeEventListener('resize', this.handleResize);
    }
  };
</script>

<style lang="scss">
    .uk-nav-side-gradient-bottom::after {
        bottom: 96px;
    }
</style>
